<script>
import { TheMask } from 'vue-the-mask';
export default {
    name: 'TwInputText',
    props: ['errors', 'type', 'name', 'value', 'placeholder', 'label', 'rules', 'class_names', 'updateFieldsForm', 'masksD', 'var', 'autocomplete', 'select_values', 'forceValidation', 'maxlenght', 'masked'],
    components: { TheMask },
    watch: {
        value: {
            handler(e) {
                this.field_value = e;
            },
            immediate: true
        },
        field_value: {
            handler(e) {
                if (this.name !== 'zip_code') {
                    this.processData(e);
                }
                this.force_validation_style = false;
                if (e !== '') {
                    this.isMounted = true;
                }
            },
            immediate: true
        },
        forceValidation: {
            handler(e) {
                if (e !== false) {
                    this.validateStyle();
                }
            }
        },
        isMounted: {
            handler(e) {
                if (e === true) {
                    this.$nextTick(() => {
                        // Se for campo de CEP com valor válido, verificamos se está completo
                        if (this.name === 'zip_code' && this.field_value && this.field_value.trim() !== '') {
                            const zipCodeClean = this.field_value.replace(/\D/g, '');
                            if (zipCodeClean.length === 8) {
                                // Usar nosso método centralizado para atualização consistente
                                this.forceZipCodeUpdate(this.field_value);
                                // Ainda processamos os dados para atualizar o formulário
                                this.processData(this.field_value, 'isMounted');
                            }
                        } else {
                            // Para outros campos, comportamento normal
                            this.processData(this.field_value, 'isMounted');
                        }
                    })
                }
            },
            immediate: true
        },
        isFocused: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                }
            }
        },
        isEnter: {
            handler(e) {
                if (e !== false) {
                    this.validateStyle();
                    this.processData(this.field_value, 'isEnter');
                }
            }
        },
        isClick: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                }
            }
        },
        isBlur: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                }
            }
        },
        isChange: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                    if (this.name !== 'zip_code') {
                        this.processData(this.field_value, 'isChange');
                    }
                }
            }
        },
        observeFocusOut: {
            handler(e) {
                if (e !== false) {
                    // Verifica se é o campo de CEP
                    if (this.name === 'zip_code' && this.field_value && this.field_value.trim() !== '') {
                        const zipCodeClean = this.field_value.replace(/\D/g, '');
                        if (zipCodeClean.length === 8) {
                            // Usar nosso método central para atualizar o CEP/frete
                            this.forceZipCodeUpdate(this.field_value);
                        } else {
                            // Se o CEP estiver incompleto, limpar
                            this.$emit('cep-clear');
                        }
                    } else {
                        // Para outros campos, comportamento normal
                        this.processData(this.field_value, 'isFocusOut');
                    }
                }

                // Reseta os flags de estado
                this.isFocused = false;
                this.isEnter = false;
                this.isClick = false;
                this.isFocusOut = false;
                this.isBlur = false;
                this.isChange = false;
                this.isClickSubmitButton = false;
                this.isInputSubmit = false;

                this.force_validation_style = false;
            }
        },
        clickSubmitButton: {
            handler(e) {
                if (e === true) {
                    this.isClickSubmitButton = true;
                } else {
                    this.isClickSubmitButton = false;
                }
            }
        },
        inputSubmit: {
            handler(e) {
                if (e === true) {
                    this.isInputSubmit = true;
                } else {
                    this.isInputSubmit = false;
                }
            }
        }
    },
    computed: {
        observeFocusOut() {
            return this.isFocusOut;
        },
        clickSubmitButton() {
            return this.$store.getters['getFormState'].clickSubmitButton;
        },
        inputSubmit() {
            return this.$store.getters['getFormState'].inputSubmit;
        }
    },
    mounted() {
        // Verificar se é campo de CEP e tem valor ao montar o componente
        if (this.name === 'zip_code' && this.value && this.value.trim() !== '') {
            // Verificar se o CEP está completo (8 dígitos)
            const zipCodeClean = this.value.replace(/\D/g, '');
            if (zipCodeClean.length === 8) {
                // Usar nosso método centralizado para atualizar o CEP e frete
                this.$nextTick(() => {
                    this.forceZipCodeUpdate(this.value);
                });
            }
        }
        
        // Adicionar listener para o evento cep-clear emitido por este componente
        this.$on('cep-clear', this.handleCepClear);
    },
    beforeDestroy() {
        // Remover listener para evitar memory leaks
        this.$off('cep-clear', this.handleCepClear);
    },
    methods: {
        containsEmoji(value) {
            const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}-\u{2B55}]/gu;
            return emojiRegex.test(value);
        },
        required() {
            if (!this.field_value || this.field_value.length === 0) {
                this.msg_error = this.errors || "Este campo é obrigatório";
                return false;
            } else {
                this.msg_error = "";
                return true;
            }
        },
        minlenght() {
            if (this.field_value && (parseInt(this.field_value.length) < parseInt(this.rules.minlenght))) {
                this.msg_error = "Verifique este campo";
                return false;
            } else {
                this.msg_error = "";
                return true;
            }
        },
        fullNameValidate() {
            if (this.field_value) {
                const specialCharsRegex = /[!@#\$%\^\&*\)\(+=._-]/g;
                if (specialCharsRegex.test(this.field_value)) {
                    this.msg_error = "O nome não deve conter caracteres especiais";
                    return false;
                }

                if (this.containsEmoji(this.field_value)) {
                    this.msg_error = "O nome não deve conter emojis";
                    return false;
                }

                let fullname = this.field_value.split(' ');

                if (typeof fullname[1] !== 'undefined' && fullname[1] !== '') {
                    this.msg_error = "";
                    return true;
                } else {
                    this.msg_error = "Informe seu nome completo";
                    return false;
                }

            } else {
                this.msg_error = "Informe seu nome completo";
                return false;
            }
        },

        email() {
            try {
                let emailzero = this.field_value.toLowerCase();
                let email = emailzero.replace(/\s+/g, '');

                if (this.containsEmoji(email)) {
                    this.msg_error = "O e-mail não deve conter emojis";
                    return false;
                }

                this.field_value = email;

                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                if (!re.test(email)) {
                    this.msg_error = "E-mail inválido";
                    return false;
                } else {
                    this.msg_error = "";
                    return true;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate Email`, message: `${error}` })
                });
            }
        },

        phone_number() {
            try {
                let phone_numberzero = this.field_value;
                let phone_number = phone_numberzero.replace(/\s+/g, '');

                if (this.containsEmoji(phone_number)) {
                    this.msg_error = "O número de telefone não deve conter emojis";
                    return false;
                }

                if (/^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/.test(phone_number)) {
                    this.msg_error = "";
                    return true;
                } else if (/^(00|)[1-9]{1}([0-9][\s]*){9,16}$/.test(phone_number)) {
                    this.msg_error = "";
                    return true;
                } else if (/^(00|\+)[1-9]{1}([0-9][\s]*){9,16}$/.test(phone_number)) {
                    this.msg_error = "";
                    return true;
                } else {
                    this.msg_error = "Telefone informado é inválido";
                    return false;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate phone_number`, message: `${error}` })
                });
            }
        },

        document() {
            try {
                let document = this.field_value;

                if (this.containsEmoji(document)) {
                    this.msg_error = "O CPF ou CNPJ não deve conter emojis";
                    return false;
                }

                if ((document.toString().length != 11 || /^(\d)\1{10}$/.test(document)) && (document.toString().length != 14 || /^(\d)\1{14}$/.test(document)) ) {
                    this.msg_error = 'CPF ou CNPJ inválido'

                    return false
                }

                if (document) {
                    document = document.replace(/\D/g, '')
                    var result = document.toString().length === 11 ? this.validarCPF(document) : this.validarCNPJ(document)

                    if (result === true) {
                        this.msg_error = "";
                    } else {
                        this.msg_error = "CPF ou CNPJ inválido";
                    }

                    return result;
                } else {
                    this.msg_error = "CPF ou CNPJ inválido";
                    return false;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate document`, message: `${error}` })
                });
            }
        },

        zip_code() {
            if (this.containsEmoji(this.field_value)) {
                this.msg_error = "O CEP não deve conter emojis";
                return false;
            }
            try {
                if(this.field_value){
                    let zip_code = this.field_value.replace(/^(\+)|\D/g, "$1").trim();

                    if (!/\d{5}-?\d{3}/.test(zip_code)) {
                        this.msg_error = "CEP inválido";
                        return false;
                    } else {
                        this.msg_error = "";
                        return true;
                    }
                }else{
                    this.msg_error = "CEP inválido";
                    return false;
                }

            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate zip_code`, message: `${error}` })
                });
            }
        },
        validarCPF(cpf) {
            let result = true;

            [9, 10].forEach(function(j) {
                var soma = 0,
                    r
                cpf.split(/(?=)/)
                    .splice(0, j)
                    .forEach(function(e, i) {
                        soma += parseInt(e) * (j + 2 - (i + 1))
                    })
                r = soma % 11
                r = r < 2 ? 0 : 11 - r
                if (r != cpf.substring(j, j + 1)) result = false
            })

            return result
        },
        validarCNPJ(cnpj) {
            cnpj = cnpj.replace(/\D/g, '')

            if (cnpj.length !== 14) return false

            let result = true

            const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            [12, 13].forEach(function(j) {
                let soma = 0, r

                cnpj.split(/(?=)/)
                    .splice(0, j)
                    .forEach(function(e, i) {
                        soma += parseInt(e) * (j === 12 ? pesos1[i] : pesos2[i])
                    })

                r = soma % 11
                r = r < 2 ? 0 : 11 - r

                if (r != cnpj.substring(j, j + 1)) result = false
            })

            return result
        },

        validateExpirationDate() {
            try {
                var expirationErrorNo;
                var expirationDate = this.field_value;
                if (!expirationDate) {
                    expirationErrorNo = 1;
                    this.msg_error = 'Data de validade do cartão inválida';
                    return false;
                }

                var datePattern = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
                if (!datePattern.test(expirationDate)) {
                    expirationErrorNo = 2;
                    this.msg_error = 'Formato de data de validade do cartão inválido';
                    return false;
                }

                var [month, year] = expirationDate.split('/').map(part => parseInt(part));

                if (month < 1 || month > 12) {
                    expirationErrorNo = 2;
                    this.msg_error = 'Mês de validade do cartão inválido';
                    return false;
                }

                var currentYear = new Date().getFullYear() % 100;
                var maxAllowedYear = currentYear + 10;
                if (year < currentYear || year > maxAllowedYear) {
                    expirationErrorNo = 2;
                    this.msg_error = 'Ano de validade do cartão inválido';
                    return false;
                }

                return true;
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate validateExpirationDate`, message: `${error}` })
                });
            }
        },
        validateCreditcard() {
            try {
                a = this.field_value.replace(/\s+/g, '');
                if (/[^0-9 \-]+/.test(a)) return !1;
                var c, d, e = 0,
                    f = 0,
                    g = !1;
                if (a = a.replace(/\D/g, ""), a.length < 13 || a.length > 19) return !1;
                for (c = a.length - 1; c >= 0; c--) d = a.charAt(c), f = parseInt(d, 10), g && (f *= 2) > 9 && (f -= 9), e += f, g = !g;
                return e % 10 === 0
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate expirationDate`, message: `${error}` })
                });
            }
        },
        validateCardNumber() {
            try {
                var cardNumber = this.field_value.replace(/\s/g, '');
                let sum = 0;
                for (let i = 0; i < cardNumber.length; i++) {
                    let digit = parseInt(cardNumber.charAt(i));
                    if (i % 2 === 0) {
                        digit *= 2;
                        if (digit > 9) {
                            digit = (digit % 10) + 1;
                        }
                    }
                    sum += digit;
                }
                if (sum % 10 !== 0) {
                    this.msg_error = 'Número de cartão inválido';
                    return false;
                }
                this.msg_error = 'Número de cartão válido';
                return true;
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate validateCardNumber`, message: `${error}` })
                });
            }
        },
        validateCardNumberNew() {
            var cardnumber = this.field_value;
            var ccErrorNo = 0;
            var ccErrors = new Array ()

            ccErrors [0] = "Unknown card type";
            ccErrors [1] = "No card number provided";
            ccErrors [2] = "Credit card number is in invalid format";
            ccErrors [3] = "Credit card number is invalid";
            ccErrors [4] = "Credit card number has an inappropriate number of digits";
            ccErrors [5] = "Warning! This credit card number is associated with a scam attempt";

            // Array to hold the permitted card characteristics
            var cards = new Array();

            // Define the cards we support. You may add addtional card types as follows.

            //  Name:         As in the selection box of the form - must be same as user's
            //  Length:       List of possible valid lengths of the card number for the card
            //  prefixes:     List of possible prefixes for the card
            //  checkdigit:   Boolean to say whether there is a check digit

            cards [0] = { name: "Visa",
                        length: "13,16",
                        prefixes: "4",
                        checkdigit: true };
            cards [1] = { name: "MasterCard",
                        length: "16",
                        prefixes: "51,52,53,54,55",
                        checkdigit: true };
            cards [2] = { name: "CarteBlanche",
                        length: "14",
                        prefixes: "300,301,302,303,304,305",
                        checkdigit: true };
            cards [3] = { name: "AmEx",
                        length: "15",
                        prefixes: "34,37",
                        checkdigit: true };
            cards [4] = { name: "Discover",
                        length: "16",
                        prefixes: "6011,622,64,65",
                        checkdigit: true };
            cards [5] = { name: "JCB",
                        length: "16",
                        prefixes: "35",
                        checkdigit: true };
            cards [6] = { name: "enRoute",
                        length: "15",
                        prefixes: "2014,2149",
                        checkdigit: true };
            cards [7] = { name: "Solo",
                        length: "16,18,19",
                        prefixes: "6334,6767",
                        checkdigit: true };
            cards [8] = { name: "Switch",
                        length: "16,18,19",
                        prefixes: "4903,4905,4911,4936,564182,633110,6333,6759",
                        checkdigit: true };
            cards [9] = { name: "Maestro",
                        length: "12,13,14,15,16,18,19",
                        prefixes: "5018,5020,5038,6304,6759,6761,6762,6763",
                        checkdigit: true };
            cards [10] = { name: "VisaElectron",
                        length: "16",
                        prefixes: "4026,417500,4508,4844,4913,4917",
                        checkdigit: true };
            cards [11] = { name: "LaserCard",
                        length: "16,17,18,19",
                        prefixes: "6304,6706,6771,6709",
                        checkdigit: true };

            // Establish card type
            var cardType = '';
            for (var i=0; i<cards.length; i++) {
                var lengths = cards[i].length.split(",");
                var prefixes = cards[i].prefixes.split(",");

                for (j=0; j<lengths.length; j++) {
                    if (cardnumber.length == parseInt(lengths[j])) {
                        for(var k =0; k< prefixes.length; k++) {
                            var prefLength = prefixes[k].length;
                            if(prefixes[k] == cardnumber.substring(0, prefLength)) {
                                cardType = cards[i].name;
                                break;
                            }
                        }
                    }
                }
            }

            // If card type not found, report an error
            //   if (cardType == -1) {
            //      ccErrorNo = 0;
            //      return false;
            //   }

            // Ensure that the user has provided a credit card number
            if (cardnumber.length == 0)  {
                ccErrorNo = 1;

                this.msg_error = 'Número de cartão inválido';
                return false;
            }



            // Now remove any spaces from the credit card number
            var cardnumber = cardnumber.replace (/\s/g, "");

            // Check that the number is numeric
            var cardNo = cardnumber

            var cardexp = /^[0-9]{13,19}$/;
            if (!cardexp.exec(cardNo))  {
                ccErrorNo = 2;

                this.msg_error = 'Número de cartão inválido';
                return false;
            }

            // Now check the modulus 10 check digit - if required
            if (true) {
                var checksum = 0;                                  // running checksum total
                var mychar = "";                                   // next char to process
                var j = 1;                                         // takes value of 1 or 2

                // Process each digit one by one starting at the right
                var calc;
                for (i = cardNo.length - 1; i >= 0; i--) {

                // Extract the next digit and multiply by 1 or 2 on alternative digits.
                calc = Number(cardNo.charAt(i)) * j;

                // If the result is in two digits add 1 to the checksum total
                if (calc > 9) {
                    checksum = checksum + 1;
                    calc = calc - 10;
                }

                // Add the units element to the checksum total
                checksum = checksum + calc;

                // Switch the value of j
                if (j ==1) {j = 2} else {j = 1};
                }

                // All done - if checksum is divisible by 10, it is a valid modulus 10.
                // If not, report an error.
                if (checksum % 10 != 0)  {
                    ccErrorNo = 3;

                    this.msg_error = 'Número de cartão inválido';
                    return false;
                }
            }

            // Check it's not a spam number
            if (cardNo == '5490997771092064') {
                ccErrorNo = 5;

                this.msg_error = 'Número de cartão inválido';
                return false;
            }

            return true;
        },
        checkValid() {
            try {
                if (typeof this.field_value !== 'undefined') {
                    if (this.rules) {
                        let checkValidResult = false;

                        if (this.rules.required) {
                            checkValidResult = this.required();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.email) {
                            checkValidResult = this.email();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.minlenght) {
                            checkValidResult = this.minlenght();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.fullNameValidate) {
                            checkValidResult = this.fullNameValidate();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.phone_number) {
                            checkValidResult = this.phone_number();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.document) {
                            checkValidResult = this.document();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.zip_code) {
                            checkValidResult = this.zip_code();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.validateExpirationDate) {
                            checkValidResult = this.validateExpirationDate();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.validateCardNumber) {
                            checkValidResult = this.validateCardNumber();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.validateCardNumberNew) {
                            checkValidResult = this.validateCardNumberNew();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                    } else {
                        this.valid = true;
                    }
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate checkValid`, message: `${error}` })
                });
            }
        },
        updateField(e, event) {
            try {
                this.field_value = e;
                if (typeof e !== 'undefined') {
                    // Condição mais rigorosa: não emitir evento para campo zip_code exceto em blur ou enter
                    const isZipCodeWithoutBlurOrEnter = this.name === 'zip_code' && 
                                                    event !== 'blur' && 
                                                    event !== 'enter' &&
                                                    event !== 'isMounted';
                    
                    if (!isZipCodeWithoutBlurOrEnter) {
                        this.$emit('updateFieldsForm', {
                            valid: this.valid,
                            field: this.name,
                            var: this.var,
                            value: this.field_value,
                            event: event,
                            eventsModel: {
                                isFocused: this.isFocused,
                                isClick: this.isClick,
                                isBlur: this.isBlur,
                                isChange: this.isChange,
                                isEnter: this.isEnter,
                                isFocusOut: this.isFocusOut,
                                isClickSubmitButton: this.isClickSubmitButton,
                                isInputSubmitAction: this.isInputSubmit
                            }
                        });
                    }
                } else {
                    console.log("updateField else")
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate updateField`, message: `${error}` })
                });
            }
        },
        validateStyle() {
            try {
                if (!this.touched) return;

                if (this.rules) {

                    if (this.valid === true) {
                        this.force_validation_style = false;

                        if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                            // console.log("Action: 0 - Input", this.name, {
                            //     isFocused: this.isFocused,
                            //     isClick: this.isClick,
                            //     isBlur: this.isBlur,
                            //     isEnter: this.isEnter,
                            //     isFocusOut: this.isFocusOut,
                            //     isClickSubmitButton: this.isClickSubmitButton,
                            //     isInputSubmitAction: this.isInputSubmit,
                            //     isValid: this.valid
                            // });

                        }

                    } else {
                        this.$nextTick(() => {

                            if (this.isFocused === true && (this.isClickSubmitButton === true || this.isInputSubmit === true || this.value !== '')) { // FOCUS SEM CLIQUE NO INPUT
                                this.force_validation_style = true;

                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    // console.log("Action: 1 - Input", this.name, {
                                    //     isFocused: this.isFocused,
                                    //     isClick: this.isClick,
                                    //     isBlur: this.isBlur,
                                    //     isEnter: this.isEnter,
                                    //     isFocusOut: this.isFocusOut,
                                    //     isClickSubmitButton: this.isClickSubmitButton,
                                    //     isInputSubmitAction: this.isInputSubmit
                                    // });
                                }

                            } else if (this.isEnter === true) { // PRESSIONOU ENTER DENTRO DO INPUT
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    // console.log("Action: 2 - Input", this.name);
                                }
                                this.isEnter = false;
                            } else if (this.isClickSubmitButton === true) { // CLICK BUTTON SUBMIT
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    // console.log("Action: 7 - Input", this.name);
                                }
                                this.isClickSubmitButton = false;
                            } else if (this.isFocused === true && this.field_value !== '' && this.isClickSubmitButton === true) { // FOCUS SEM CLIQUE NO INPUT
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    // console.log("Action: 3 - Input", this.name);
                                }
                                this.isFocused = false;
                                this.isClickSubmitButton = false;
                            } else if (this.isBlur === true && this.value != "") { // PRESSIONOU ENTER DENTRO DO INPUT
                                this.force_validation_style = true;
                                this.isBlur = false;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    // console.log("Action: 4 - Input", this.name);
                                }
                            } else if (this.forceValidation === true) {
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    // console.log("Action: 5 - Input", this.name);
                                }
                            } else {
                                this.force_validation_style = false;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                }
                            }
                        })

                    }
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate validateStyle`, message: `${error}` })
                });
            }
        },
        processData(e, event = null) {
            // Se for o campo de CEP e não for um evento de blur ou enter, apenas valida sem emitir eventos
            const isCepFieldNotFinalEvent = this.name === 'zip_code' && 
                                          event !== 'blur' && 
                                          event !== 'enter' && 
                                          event !== 'isMounted';
            
            // Sempre verificamos a validade do campo
            this.checkValid();
            
            if (!this.touched) {
                this.msg_error = "";
            }
            
            if (!isCepFieldNotFinalEvent) {
                this.$nextTick(() => {
                    this.updateField(e, event);
                });
            }
        },
        markAsTouched() {
            this.touched = true;
            if (!this.checkValid()) {
                this.force_validation_style = true;     
            }
            document.getElementById(this.name)?.focus();
            
        },
        handleInputBlur(event) {
            this.isBlur = true;
            
            // Se o campo for CEP
            if (this.name === 'zip_code') {
                // Verifica se o campo está vazio ou com valor inválido
                if (!this.field_value || this.field_value.trim() === '') {
                    // Limpa o frete
                    this.$emit('cep-clear');
                    return;
                }
                
                // Para CEP com valor, verifica se está completo (8 dígitos)
                const zipCodeClean = this.field_value.replace(/\D/g, '');
                if (zipCodeClean.length === 8) {
                    // Força a atualização do CEP e do frete
                    this.forceZipCodeUpdate(this.field_value);
                    
                    // Atualiza o campo no formulário
                    this.$emit('updateFieldsForm', {
                        valid: true,
                        field: this.name,
                        var: this.var,
                        value: this.field_value,
                        event: 'blur',
                        eventsModel: {
                            isFocused: this.isFocused,
                            isClick: this.isClick,
                            isBlur: this.isBlur,
                            isChange: this.isChange,
                            isEnter: this.isEnter,
                            isFocusOut: this.isFocusOut,
                            isClickSubmitButton: this.isClickSubmitButton,
                            isInputSubmitAction: this.isInputSubmit
                        }
                    });
                } else {
                    // Se o CEP está incompleto, limpa o frete
                    this.$emit('cep-clear');
                }
            }
        },
        handleInputChange(event) {
            if (this.name === 'zip_code') {
                const maskedValueFromDOM = event.target.value; // Valor MASCARADO do input DOM

                // Verifica se o valor MASCARADO no DOM tem 9 caracteres
                if (maskedValueFromDOM && maskedValueFromDOM.length === 9) {
                    // Neste ponto, this.field_value (o valor não mascarado) deve ter 8 dígitos
                    // se a TheMask atualizou o v-model corretamente.
                    if (this.field_value && this.field_value.length === 8) {
                        this.validateStyle(); 
                        this.forceZipCodeUpdate(this.field_value); // Passa o valor NÃO MASCARADO do v-model
                    } else {
                        // Fallback caso this.field_value não esteja sincronizado como esperado.
                        // Limpa o valor mascarado e verifica se tem 8 dígitos.
                        const unmaskedFallback = maskedValueFromDOM.replace(/\D/g, '');
                        if (unmaskedFallback.length === 8) {
                            this.validateStyle();
                            this.forceZipCodeUpdate(unmaskedFallback);
                        }
                    }
                }
                
                // Lógica restante comum para CEP (validação visual, clear)
                this.isChange = true; 
                this.validateStyle(); 
                
                if (!maskedValueFromDOM || maskedValueFromDOM.trim() === '') {
                    this.$emit('cep-clear');
                    // Não há necessidade de 'return' aqui, pois a lógica principal de disparo já foi tratada.
                }
            } else {
                // Para outros campos
                this.isChange = true; 
            }
        },
        handleInputEnter(event) {
            this.isEnter = true;
            this.touched = true;
            
            // Para o campo de CEP
            if (this.name === 'zip_code') {
                // Verifica se o campo está vazio ou com valor inválido
                if (!this.field_value || this.field_value.trim() === '') {
                    // Limpa o frete
                    this.$emit('cep-clear');
                    return;
                }
                
                // Emite o evento para campo de CEP apenas se estiver completo
                const zipCodeClean = this.field_value.replace(/\D/g, '');
                if (zipCodeClean.length === 8) {
                    // Força a atualização do CEP e do frete
                    this.forceZipCodeUpdate(this.field_value);
                    
                    // Atualiza o campo no formulário
                    this.$emit('updateFieldsForm', {
                        valid: true,
                        field: this.name,
                        var: this.var,
                        value: this.field_value,
                        event: 'enter',
                        eventsModel: {
                            isFocused: this.isFocused,
                            isClick: this.isClick,
                            isBlur: this.isBlur,
                            isChange: this.isChange,
                            isEnter: this.isEnter,
                            isFocusOut: this.isFocusOut,
                            isClickSubmitButton: this.isClickSubmitButton,
                            isInputSubmitAction: this.isInputSubmit
                        }
                    });
                } else {
                    // Se o CEP está incompleto, limpa o frete
                    this.$emit('cep-clear');
                }
            } else {
                // Para outros campos, processamento normal
                this.processData(this.field_value, 'isEnter');
            }
        },
        // Método para forçar a atualização do frete baseado no CEP
        forceZipCodeUpdate(zipCode) {
            // Se não tiver CEP completo, não faz nada
            if (!zipCode || zipCode.trim() === '') {
                this.$emit('cep-clear');
                return;
            }
            
            const zipCodeClean = zipCode.replace(/\D/g, '');
            if (zipCodeClean.length !== 8) {
                this.$emit('cep-clear');
                return;
            }
            
            // Força atualização direta do CEP no Vuex store
            if (this.$store && this.$store.commit && this.$store.getters) {
                try {
                    // Primeiro, certifique-se de que o campo tenha o valor atual
                    this.field_value = zipCode;
                    
                    // Atualiza o customer com o CEP válido
                    const customer = JSON.parse(JSON.stringify(this.$store.getters.getCustomer || {}));
                    customer.zip_code = zipCode;
                    this.$store.commit('setCustomer', customer);
                    
                    // Emite eventos para componentes pais
                    this.$emit('cep-changed', zipCode);
                    this.$emit('cep-blurred', zipCode);
                    
                    // Emite o evento updateFieldsForm para processar o CEP
                    this.$emit('updateFieldsForm', {
                        valid: true,
                        field: this.name,
                        var: this.var,
                        value: zipCode,
                        event: 'blur', // Usamos 'blur' para assegurar que o CEP será processado
                        eventsModel: {
                            isFocused: false,
                            isClick: false,
                            isBlur: true,
                            isChange: false,
                            isEnter: false,
                            isFocusOut: true,
                            isClickSubmitButton: false,
                            isInputSubmitAction: false
                        }
                    });
                    
                    // Força a atualização do frete através de uma action assíncrona se disponível
                    if (this.$store.dispatch) {
                        this.$store.dispatch('callEventTracker', { 
                            event: 'zipcode_updated', 
                            extra_params: { zipcode: zipCode } 
                        });
                    }
                } catch (error) {
                    console.error('Erro ao atualizar CEP:', error);
                }
            }
        },
        // Método para limpar o frete no Vuex quando o CEP está vazio
        handleCepClear() {
            // Limpar o frete no Vuex store
            if (this.$store && this.$store.commit) {
                this.$store.commit('clearShipping');
                
                // Também atualizamos o customer sem CEP
                const customer = this.$store.getters.getCustomer || {};
                customer.zip_code = '';
                this.$store.commit('setCustomer', customer);
            }
        },
        // Novo método para lidar com a tecla tab
        handleInputTab(event) {
            // Se for o campo de CEP e tiver um valor válido
            if (this.name === 'zip_code' && this.field_value && this.field_value.trim() !== '') {
                const zipCodeClean = this.field_value.replace(/\D/g, '');
                if (zipCodeClean.length === 8) {
                    // Primeiro atualizamos o valor para ter certeza
                    this.field_value = this.field_value;
                    
                    // Emitimos o evento de form update com o evento tab específico
                    this.$emit('updateFieldsForm', {
                        valid: true,
                        field: this.name,
                        var: this.var,
                        value: this.field_value,
                        event: 'tab',
                        eventsModel: {
                            isFocused: false,
                            isClick: false,
                            isBlur: false,
                            isChange: false,
                            isEnter: false,
                            isFocusOut: true,
                            isClickSubmitButton: false,
                            isInputSubmitAction: false
                        }
                    });
                    
                    // E então forçamos a atualização do CEP/frete
                    setTimeout(() => {
                        this.forceZipCodeUpdate(this.field_value);
                    }, 50);
                }
            }
        },
    },
    data() {
        return {
            msg_error: "",
            field_value: "",
            valid: false,
            force_validation_style: false,
            isMounted: false,
            isFocused: false,
            isClick: false,
            isBlur: false,
            isEnter: false,
            isFocusOut: false,
            isClickSubmitButton: false,
            isChange: false,
            isInputSubmit: false,
            timeout: null,
            touched: false,
        }
    }
}
</script>
<template>
    <div :class="class_names">
        <div v-if="type !== 'select'"
            class="relative rounded-md border-2 border-gray-300 px-2 py-2 my-3 sm:mx-1 shadow-inner focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-300"
            :class="{ 'border-red-500  ring-red-300 focus-within:ring-red-300 focus-within:border-red-500 group-error invalid': (msg_error.length > 0) }">
            <label v-if="(msg_error.length === 0)" :for="name"
                class="absolute overflow-hidden -top-2 left-2 -mt-px inline-block bg-white px-1 text-sm text-gray-800 font-bold">{{
                    label }}
            </label>
            <label v-else-if="msg_error"
                class="absolute -top-2 left-2 -mt-px inline-block bg-white overflow-hidden px-1 text-sm font-medium text-red-600 invalid"
                id="email-error">{{ msg_error }}</label>
            <!--  @blur.native="validateStyle()" -->
            <TheMask
                v-if="masksD"
                :mask="masksD"
                :masked="masked"
                @blur.native="handleInputBlur"
                @change.native="handleInputChange"
                @input.native="handleInputChange"
                @click.native="(isClick = true, touched = true)"
                @keypress.enter.native="handleInputEnter"
                @keydown.tab.native="handleInputTab"
                v-model.trim="field_value"
                :value="value"
                :ref="name"
                :type="type"
                :name="name"
                :id="name"
                :maxlenght="maxlenght"
                class="block w-full py-1 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 border-0 sm:text-sm"
                :class="{ 'placeholder-red-200 invalid-field': (touched && msg_error.length > 0) }"
                :autocomplete="autocomplete"
                :inputmode="type"
                autocapitalize="off"
                autocorrect="off"
                spellcheck="false"
                :placeholder="(value == '') ? placeholder : ''"
            />

            <input v-else
                @blur="handleInputBlur"
                @keypress.enter="handleInputEnter"
                @keydown.tab="handleInputTab"
                @change="handleInputChange"
                @input="handleInputChange"
                @focusout="isFocusOut = true"
                @focus="(isFocused = true, touched = true)"
                @click="(isClick = true, touched = true)"
                v-model.trim="field_value"
                :value="value"
                :ref="name"
                :type="type"
                :name="name"
                :id="name"
                :maxlenght="maxlenght"
                class="block w-full py-1 p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
                :class="{ 'placeholder-red-200 invalid-field': (touched && msg_error.length > 0) }"
                :autocomplete="autocomplete"
                :inputmode="type"
                autocapitalize="off"
                autocorrect="off"
                spellcheck="false"
                :placeholder="(value == '') ? placeholder : ''"
            />

            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
                v-if="(msg_error.length > 0)">

            </div>
        </div>

        <div v-if="type == 'select'"
            class="relative rounded-md border-2 border-gray-300 shadow-inner my-3 sm:mx-1 px-1 focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-300"
            :class="{ 'border-red-500  ring-red-300 focus-within:ring-red-300 focus-within:border-red-500 invalid': (msg_error.length > 0) }">
            <label :for="name"
                class="absolute overflow-hidden -top-2 left-2 -mt-px inline-block bg-white px-1 text-xs font-medium text-gray-900">{{
                    label }}</label>

            <select @blur="isBlur = true;" @keypress.enter="handleInputEnter" @change="isChange = true" v-model="field_value"
                :value="value" :ref="name" :type="type" :name="name" :id="name"
                class="block w-full text-gray-900 border-0 focus:ring-0 sm:text-sm"
                :class="{ 'placeholder-red-200 invalid-field': (msg_error.length > 0) }" :autocomplete="autocomplete"
                :inputmode="type" autocapitalize="off" autocorrect="off" spellcheck="false"
                :placeholder="(value == '') ? placeholder : ''">
                <option value="">Selecione</option>
                <option :value="item" v-for="(item, index) in select_values" :key="index">{{ item }}</option>
            </select>


            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
                v-if="(msg_error.length > 0)">

            </div>
        </div>
    </div>
</template>

<style scoped>
    input:-webkit-autofill+label {
        -webkit-transform: translateY(-14px) scale(0.8);
        transform: translateY(-14px) scale(0.8);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }

    button{
        margin-top: 10px;
        margin-bottom:10px;
    }

    label {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-top: 10px;
        /* some width */
    }

    .invalid{
        color:#e50f38
    }

    .invalid-field{
        background: #feecef;
        border-color: #e50f38;
    }
</style>
